import "./Styles.js";

import ContentCardReport from "../../components/report/ContentCardReport";

const ReportTeacher = ({ teacherId }) => {
  return (
    <div className="reportTeacher">
      <ContentCardReport teacherId={teacherId} />
    </div>
  );
};

export default ReportTeacher;
